module.exports = __webpack_public_path__ + "img/experience-banner.e03b2f5d.jpg";